<template>
    <div id="simulator">
        <!--=====================================-->
        <!--=        Counter Up Area Start      =-->
        <!--=====================================-->
        <section class="section mb--100" data-sal="slide-up" data-sal-duration="800">
            <div class="container">
                <div class="section-heading">
                    <span class="subtitle primary bold">Simulador.</span>
                    <h2 class="title font-weight-100">Descubre cuánto puedes <span class="bold">ganar.</span></h2>
                </div>
                <div class="row">
                    <div class="col-12 text-align-center mb--30">
                        <label for="customRange1" class="form-label label-value mb-4">{{ this.explicitMoneyFormat(value, 0) }} invertidos por tus referidos.</label>
                        <input 
                            v-model="value" 
                            type="range" 
                            class="form-range custom-range" 
                            color="primary" 
                            min="0" 
                            step="10000"
                            max="30000000" 
                            id="customRange1">
                        <div class="range-tags">
                            <span class="bold">$0</span>
                            <span class="bold">$30,000,000</span>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 col-md-3 col-lg-3 text-align-center">
                                <p class="form-label bold">Comisión</p>
                                <div class="pill dark">
                                    {{ getCurrentCommissionPercentage }} % anual
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-3 text-align-center">
                                <p class="form-label bold">Ingreso pasivo</p>
                                <div class="pill primary">
                                    {{ this.explicitMoneyFormat(value * getCurrentCommissionValue, 0) }} mensual
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import formatHelper from "@mixins/formatHelper.js"
    export default {
        name: "Simulator",
        mixins: [formatHelper],
        data: () => ({
            value: 15000000,
        }),
        computed: {
            getCurrentCommissionPercentage()
            {
                let percentage = "0"
                if (this.value >= 1 && this.value <= 1000000) {
                    percentage = "0.60";
                } else if (this.value >= 1000001 && this.value <= 5000000) {
                    percentage = "1.20"
                } else if (this.value >= 5000001 && this.value <= 10000000) {
                    percentage = "1.80";
                } else if (this.value >= 10000001 && this.value <= 25000000) {
                    percentage = "2.40";
                } else if (this.value >= 25000001 ) {
                    percentage = "3.00";
                }

                return percentage;
            },
            getCurrentCommissionValue()
            {
                let percentage = 0;
                if (this.value >= 1 && this.value <= 1000000) {
                    percentage = 0.0005;
                } else if (this.value >= 1000001 && this.value <= 5000000) {
                    percentage = 0.001;
                } else if (this.value >= 5000001 && this.value <= 10000000) {
                    percentage = 0.0015;
                } else if (this.value >= 10000001 && this.value <= 25000000) {
                    percentage = 0.0020;
                } else if (this.value >= 25000001 ) {
                    percentage = 0.0025;
                }

                return percentage;
            },

        }
    }
</script>

<style scoped>

.range-tags {
    display: flex;
    justify-content: space-between;
}

.custom-range::-webkit-slider-thumb {
  background: var(--color-primary);
}

.custom-range::-moz-range-thumb {
  background: var(--color-primary);
}

.custom-range::-ms-thumb {
  background: var(--color-primary);
}

.label-value {
    border: 1px solid;
    border-radius: 20px;
    padding: 5px 20px 5px 20px;
}

.pill{
    border: 1px solid transparent;
    padding: 5px;
    margin: 5px 20px 5px 20px;
    border-radius: 25px;
    font-weight: 700;
    padding: 10px 0px 10px 0px;
}

.pill.dark {
    background-color: var(--color-dark);
    color: var(--color-white);
}
.pill.primary {
    background-color: var(--color-primary);
    color: var(--color-dark) !important;
}
</style>